import React from "react";
import { formatStaffName } from "@/lib/format-data";
import { FirebaseProviderSummary } from "@/types/provider";

/**
 * Parse text with {provider_id} mentions and render with styling.
 * Mention format: {provider_id}
 */
export function renderProviderMentions(text: string, providers: FirebaseProviderSummary[]): React.ReactNode {
  if (!text) return text;

  // Pattern to match {provider_id}
  const mentionPattern = /\{([^}]+)\}/g;
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match;
  let keyCounter = 0;

  // Create provider lookup map for efficient access
  const providerMap = new Map(providers.map(p => [p.id, p]));
  while ((match = mentionPattern.exec(text)) !== null) {
    const [fullMatch, providerId] = match;
    const matchStart = match.index;

    // Add text before mention
    if (matchStart > lastIndex) {
      parts.push(text.substring(lastIndex, matchStart));
    }

    // Find the provider
    const provider = providerMap.get(providerId);
    if (provider) {
      // Add styled mention
      const name = formatStaffName(provider);
      parts.push(<span key={`mention-${keyCounter++}`} className="rounded bg-accent px-[0.3rem] py-[0.1rem] text-accent-foreground">
          @{name}
        </span>);
    } else {
      // If no provider found, show the raw variable
      parts.push(`{${providerId}}`);
    }
    lastIndex = mentionPattern.lastIndex;
  }

  // Add remaining text
  if (lastIndex < text.length) {
    parts.push(text.substring(lastIndex));
  }
  return parts.length > 0 ? parts : text;
}